import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useUser } from '@stackframe/react';

export default function StackAuthCallback() {
  const navigate = useNavigate();
  const { user: authUser, isAdmin } = useAuth();
  const stackUser = useUser();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    const handleStackAuthCallback = async () => {
      try {
        console.log('Stack callback - waiting for auth to complete...');
        
        // Wait a bit for Stack Auth to initialize
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Check if we have Stack user
        if (!stackUser) {
          console.log('No Stack user found, redirecting home');
          navigate('/', { replace: true });
          return;
        }
        
        console.log('Stack user found:', stackUser.primaryEmail);
        
        // Wait for AuthContext to sync (max 5 seconds)
        let attempts = 0;
        while (!authUser && attempts < 10) {
          console.log('Waiting for user sync...', attempts + 1);
          await new Promise(resolve => setTimeout(resolve, 500));
          attempts++;
        }
        
        if (authUser) {
          console.log('User synced! Redirecting to', isAdmin ? 'admin' : 'user dashboard');
          navigate(isAdmin ? '/admin' : '/user-dashboard', { replace: true });
        } else {
          console.log('User sync timeout, redirecting home');
          navigate('/', { replace: true });
        }
        
        setHasChecked(true);
      } catch (error) {
        console.error('Stack Auth callback error:', error);
        navigate('/', { replace: true });
      }
    };

    if (!hasChecked) {
      handleStackAuthCallback();
    }
  }, [navigate, authUser, stackUser, isAdmin, hasChecked]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white mx-auto mb-4" />
        <p className="text-white text-xl" suppressHydrationWarning>
          Completing sign in...
        </p>
      </div>
    </div>
  );
}
